import { useTranslation } from "@msuite/ui/localization";
import { Panels } from "@msuite/ui/panels";
import { SegmentedControl } from "@msuite/ui/segmented-control";
import { useState } from "react";
import type { IncomingInvoicePanelBaseProps } from "../../shared";
import { IncomingInvoiceSettingsGeneral } from "./incoming-invoice-settings-general";

type IncomingInvoiceSettingsTab = "general";

/** An invoice's settings, laid out as a project's are: the sections on the left, one shown. */
export function IncomingInvoiceSettings({ incomingInvoiceId }: IncomingInvoicePanelBaseProps) {
	/** Context */
	const { t } = useTranslation();

	/** State */
	const [activeTab, setActiveTab] = useState<IncomingInvoiceSettingsTab>("general");

	/** Render */
	return (
		<Panels>
			<Panels.Panel flex={1}>
				<SegmentedControl
					value={activeTab}
					orientation="vertical"
					onChange={setActiveTab}
					items={[
						{
							value: "general",
							label: t("general.general"),
							cyId: "incoming-invoice-settings-general-tab",
						},
					]}
				/>
			</Panels.Panel>
			<Panels.Panel
				flex={3}
				className="bottom-space"
			>
				{activeTab === "general" && (
					<IncomingInvoiceSettingsGeneral incomingInvoiceId={incomingInvoiceId} />
				)}
			</Panels.Panel>
		</Panels>
	);
}
